import React, { useEffect } from "react";
import logo from "../assets/img/Bee.net Logo White & Green@2x.png";
import certificationImg from "../assets/img/ChatGPT Image Sep 1, 2025, 12_05_16 PM.png";
import "../assets/css/footer.css";
import { Link } from "react-router-dom";
import { LuDot } from "react-icons/lu";

const Footer = () => {
  useEffect(() => {
    document.getElementById("year").textContent = new Date().getFullYear();
  }, []);

  return (
    <footer className="footer1 py-5">
      {/* Left Section */}
      <div className="custom-container d-flex justify-content-between">
        <div className="footer1-left">
          <img src={logo} alt="Bee.net Logo" className="footer1-logo" />
          <small className="copyright">
            ©<span id="year"></span> bee.net{" "}
            {/* <span className="bee-net"> bee<span className="dot-c">.</span>net</span> */}
            {/* bee<span className="dot-c">.</span>net */}
          </small>
        </div>

        {/* Right Section */}
        {/* <div className="footer1-right">
          <div className="certification">
            <img
              src={certificationImg}
              alt="Cyber Essentials Certified Plus"
              className="footerright-img"
            />
            <div className="cert-text">
              <p className="certpara">
                Bee.net is a trading name of <br />{" "}
              </p>
              <strong style={{ fontFamily: "Roboto", fontSize: "17px" }}>
                Bee-Net Services Limited
              </strong>
              <br />
              <p>
                Registered in England and Wales, no 09019437
                <br />
                Registered address: St Stephens House, Arthur Road,
                <br />
                Windsor, Berkshire, England, SL4 1RU
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
